import CustomFooter from './CustomFooter';

export default CustomFooter;
